import styled from 'styled-components';

const StyledPriceRangeSliderWrapper = styled.div`
  width: 343px;
`;

export default StyledPriceRangeSliderWrapper;
